import { AxiosResponse } from 'axios';
import React, { useEffect, useState } from 'react';
import { Link, useLocation, useParams } from 'react-router-dom';
import { useApi } from '../../../../../context/ApiProvider';
import {
  AnnouncementInterfaceWIthPagination,
  AnnouncementInterface
} from '../../../../../shared/type/announcement.interface';
import IconComponent from '../../../../IconComponent/IconComponent';
import { useParentDashboardContextContext } from '../../../../../context/ParentDashboardContext';

const SingleParentNotification = () => {
  const location = useLocation();
  const { parentDashboardContext } = useParentDashboardContextContext();
  const { apiParentMessageController } = useApi();
  const { id: announcementId } = useParams();
  const [announcement, setAnnouncement] = useState<AnnouncementInterface | undefined>(undefined);
  const basePath = location.pathname.split('/').slice(0, -2).join('/');
  const currentTenantId = parentDashboardContext?.tenants[0]?.tenantId;

  const fetchAnnouncements = async () => {
    if (!currentTenantId) return;
    try {
      const response: AxiosResponse<AnnouncementInterfaceWIthPagination> =
        await apiParentMessageController('announcement-list').get('', {
          params: {
            pageNumber: 1,
            pageSize: 10000
          }
        });

      const { data } = response.data;

      if (!data) {
        return;
      }

      const newAnnouncement = data.find(
        (announcement) => announcement.id === Number(announcementId)
      );

      setAnnouncement(newAnnouncement);
    } catch (error) {
      console.error('Error fetching announcements:', error);
    }
  };

  const markAnnouncementAsRead = async () => {
    if (!currentTenantId || !announcementId) return;
    try {
      await apiParentMessageController('mark-announcement-as-read').post('', null, {
        params: {
          announcementId: Number(announcementId)
        }
      });
    } catch (error) {
      console.error('Something wen wrong during marking as read', error);
    }
  };

  useEffect(() => {
    fetchAnnouncements();
  }, []);

  useEffect(() => {
    if (announcementId) {
      markAnnouncementAsRead();
    }
  }, [announcementId]);

  return (
    <section className="flex flex-col h-full gap-spacing-xl w-full pb-20">
      <div className="pt-spacing-md pr-spacing-3xl pb-spacing-md pl-spacing-3xl gap-spacing-md">
        <Link
          to={`${basePath}/announcements`}
          className="flex items-center gap-spacing-sm pt-2.5 pr-spacing-xl pb-2.5 pl-spacing-xl">
          <IconComponent iconName="arrowLeft" />
          <p style={{ fontSize: '16px' }} className="font-semibold text-grayWarm-950">
            Wróć
          </p>
        </Link>
        <h2 className="text-2xl font-semibold text-grayLight-900">
          Komunikat dla: {announcement?.consumerNames?.join(', ') || announcement?.topic}
        </h2>
      </div>

      {announcement && (
        <div className="pr-spacing-3xl pl-spacing-3xl flex-grow overflow-y-auto">
          <div className="min-h-spacing-11xl p-spacing-xl bg-white border border-gray-200">
            {announcement?.content}
          </div>
        </div>
      )}
    </section>
  );
};

export default SingleParentNotification;
